import { makeStyles, tokens } from '@fluentui/react-components';

// Guía de diseño: superficies planas con borde y radio 4 px, títulos de sección en mayúsculas 12 px bold,
// colores en tokens --ichtys-* (claro, oscuro y alto contraste).
export const useVisitConceptLeafModalStyles = makeStyles({
  dialogSurface: {
    maxWidth: '760px',
    width: '92vw',
    borderRadius: '4px',
  },
  contentRoot: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
  },
  contextCard: {
    backgroundColor: 'var(--ichtys-bg)',
    border: '1px solid var(--ichtys-border)',
    borderRadius: '4px',
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
  },
  contextTitle: {
    fontWeight: tokens.fontWeightBold,
    color: 'var(--ichtys-text-secondary)',
    fontSize: '12px',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
  },
  contextFlow: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    columnGap: tokens.spacingHorizontalM,
    rowGap: tokens.spacingVerticalXS,
    alignItems: 'baseline',
  },
  contextItem: {
    display: 'contents',
  },
  contextKey: {
    color: 'var(--ichtys-text-secondary)',
    fontSize: '13px',
  },
  contextValue: {
    color: 'var(--ichtys-text)',
    fontSize: '14px',
    fontWeight: tokens.fontWeightSemibold,
    display: 'inline-flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    flexWrap: 'wrap',
  },
  contextBadge: {
    color: 'var(--ichtys-text-secondary)',
    fontSize: '12px',
    fontWeight: tokens.fontWeightSemibold,
    border: '1px solid var(--ichtys-border)',
    borderRadius: '999px',
    padding: `1px ${tokens.spacingHorizontalS}`,
    fontVariantNumeric: 'tabular-nums',
  },
  contextConnector: {
    display: 'none',
  },
  statusRow: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
  },
  statusLabel: {
    fontWeight: tokens.fontWeightSemibold,
    color: 'var(--ichtys-text)',
  },
  sectionCard: {
    border: '1px solid var(--ichtys-border)',
    borderRadius: '4px',
    padding: tokens.spacingHorizontalM,
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
    backgroundColor: 'var(--ichtys-surface)',
  },
  sectionTitle: {
    fontWeight: tokens.fontWeightBold,
    color: 'var(--ichtys-text-secondary)',
    fontSize: '12px',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
  },
  fieldStack: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
  },
  selectedConceptsLabel: {
    marginTop: tokens.spacingVerticalXS,
    color: 'var(--ichtys-text-secondary)',
    fontSize: '13px',
  },
  textareaFull: {
    width: '100%',
  },
  actions: {
    marginTop: tokens.spacingVerticalXS,
  },
});
